import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import ResolvedLocaleReducer, { name as resolvedLocaleReducerName } from './ResolvedLocaleReducer';
import ResolvedThemeReducer, { name as resolvedThemeReducerName } from './ResolvedThemeReducer';
import DesignModeReducer, { name as designModeReducerName } from './DesignModeReducer';
import CheckoutReducer, { name as checkoutReducerName } from './CheckoutReducer';
import ShopifyModeReducer, { name as shopifyModeReducerName } from './ShopifyModeReducer';
import CustomSettingsReducer, { name as customSettingsReducerName } from './CustomSettingsReducer';

export default combineReducers({
  routing,
  [resolvedLocaleReducerName]: ResolvedLocaleReducer,
  [resolvedThemeReducerName]: ResolvedThemeReducer,
  [designModeReducerName]: DesignModeReducer,
  [checkoutReducerName]: CheckoutReducer,
  [shopifyModeReducerName]: ShopifyModeReducer,
  [customSettingsReducerName]: CustomSettingsReducer
});
